import { render } from "./OrphanCleanupPage.vue?vue&type=template&id=3c3cac12&scoped=true"
import script from "./OrphanCleanupPage.vue?vue&type=script&lang=js"
export * from "./OrphanCleanupPage.vue?vue&type=script&lang=js"

import "./OrphanCleanupPage.vue?vue&type=style&index=0&id=3c3cac12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3cac12"]])

export default __exports__